import styled from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';

import {
    GridContainer as GridContainerCommon,
    Wrapper as WrapperCommon,
} from '~/src/features/center/common/styled';

export const GridContainer = styled(GridContainerCommon)`
    margin-top: 0;

    @media (max-width: ${breakPoints.mobile}) {
        margin-left: 16px;
        margin-right: 16px;
    }
`;

export const Wrapper = styled(WrapperCommon)`
    padding-bottom: 75px;
    border-radius: 20px;

    @media (max-width: ${breakPoints.mobile}) {
        padding-bottom: 154px;
    }

    @media (max-width: 350px) {
        padding-bottom: 235px;
    }
`;

export const Title = styled.div`
    width: 100%;
    ${FONTS.H2};
    margin-bottom: 10px;
    white-space: pre-wrap;

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.H3};
    }
`;

export const Text = styled.div`
    width: 55%;
    ${FONTS.L};
    margin-bottom: 40px;

    @media (max-width: ${breakPoints.sDesktop}) {
        width: 100%;
    }

    @media (max-width: ${breakPoints.mobile}) {
        ${FONTS.XS};
    }
`;
